import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../../Shared/Process/Process/WizardLinter";
import { EWizardLinterHelper } from "../../../../NewBusinessWizard/Resource/EWizardLinterHelper";
import { CrystallisationDetailsSection } from "../../../../Common/SIPP/DrawdownDetails/CrystallisationDetails";
import { LTABreakdownDetails } from "../../../../Common/SIPP/DrawdownDetails/LTABreakdownDetails";
import { RegularCrystallisation } from "../../../../Common/SIPP/DrawdownDetails/RegularCrystallisation";
import { TaxFreeLumpSumPayment } from "../../../../Common/SIPP/DrawdownDetails/TaxFreeLumpSumPayment";
import { DrawdownTypeOption } from "../../../../Common/SIPP/DrawdownDetails/DrawdownType";
import { DrawdownType } from "../../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { QuoteModel } from "../../../../../../../../Wrap/Models/Models/Processes/Quote/QuoteModel";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { LessThanAge } from "../../../../Common/Helpers/PensionHelper";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { DIAC } from "../../../../Common/SIPP/DrawdownDetails/DIAC";
import { OAC } from "../../../../Common/AdviserCharges/Components/OAC";
import { ChooseAssetsToSell } from "../../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSell";
import {
    getChooseAssetsToSellTable,
    hasEnhancedPensionProtection,
    showChooseAssetstoSell,
    hasPrimaryProtection,
    hasEnhancedProtectionWithPclsProtection
} from "../../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ChooseAssetsToSellTable } from "../../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import { ProtectionInformation } from "../../../../Common/SIPP/DrawdownDetails/ProtectionInformation";
import { IllHealth } from "../../../../Common/SIPP/DrawdownDetails/IllHealth";
import { DrawdownCalculationAction } from "../../../../Common/SIPP/DrawdownDetails/Action/DrawdownCalculationAction";
import { DrawdownModel } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { QuoteInstructionStore } from "../../../Store/Variable";
import { NewQuoteAction } from "../../../Actions/NewQuoteAction";
import { getQueryParameters } from "../../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { PensionType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { PensionProtection } from "../../../../Common/SIPP/DrawdownDetails/PensionProtection";
import { ChooseAssetsToSellAssets } from "../../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { ChooseAssetsToSellFor } from "../../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { DeferredFundWarningMessage, IsRestrictedToPensionContributionWarningText } from "../../../../Common/Resource/Contents";
import { PartLoading } from "../../../../../../../../react-core/Html/PartLoading";
import { ChargesOnIllustration } from "../../../../Common/AdviserCharges/Components/ChargesOnIlustration";
import { isRestrictedToPensionContribution } from "../../../../Common/PaymentsIn/SIPP/ValidationHelper";
import { PensionOption } from "../../../../../../../../Wrap/Constants/Enums/Apply/PensionOption";
import { AllowanceDetails } from "../../../../Common/SIPP/DrawdownDetails/AllowanceDetails";
import { PCLSSection } from "../../../../Common/SIPP/DrawdownDetails/PCLSSection";
import { Money } from "../../../../../../../../Wrap/Core/DataTypes/Money";
import { CrystallisationOption } from "../../../../../../../../Wrap/Constants/Enums/Drawdown/CrystallisationOption";
import { TableKeys } from "../../../../Common/SIPP/DrawdownDetails/Resource/Constant";

interface IDrawdownDetailsProps extends IProcessComponentProps {
    data: QuoteModel;
}

interface IDrawdownDetailsState {
    isLoading: boolean;
    originType: DrawdownType;
    assetsTable: ChooseAssetsToSellAssets[];
    minimumDate_DisinvestNeed?: Date;
    minimumDate_DisinvestNoNeed?: Date;
    isDisinvest: Boolean;
}

export class DrawdownDetails extends ProcessComponent<IDrawdownDetailsProps, IDrawdownDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            originType: null,
            assetsTable: [],
            isDisinvest: true,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.setState({ assetsTable: getChooseAssetsToSellTable(this.props.data.PensionQuote) });
        if (
            !this.ageNeedsIllHealth(this.props.data) &&
            !this.props.data?.PensionQuote?.DrawdownModel?.InstructionId
        ) {
            this.setState({ isLoading: true });
            const params = getQueryParameters();
            DrawdownCalculationAction.postDrawdown(
                this.props.data?.PensionQuote?.HierarchyId,
                null,
                (drawdownModel: DrawdownModel) => {
                    NewQuoteAction.getQuoteInstruction(params["id"], (quoteModel: QuoteModel) => {
                        this.setState({ isLoading: false }, () => {
                            if (this.getIsImmediateTaxFreeLumpSum()) {
                                quoteModel.PensionQuote.DrawdownModel.CrystallisationDetails.CrystallisationOption =
                                    CrystallisationOption.Full;
                                this.doCalculation(
                                    quoteModel,
                                    quoteModel.PensionQuote?.DrawdownModel?.CrystallisationDetails
                                        ?.AvailableToCrystallise
                                );
                            }
                        });
                    });
                    this.setState({ originType: drawdownModel?.DrawdownType });
                }
            );
        }

        DrawdownCalculationAction.getMinimumPaymentDate("", true, true, (result) => {
            this.setState({
                minimumDate_DisinvestNeed: new Date(result.MinimumDateTime),
            });
        });

        DrawdownCalculationAction.getMinimumPaymentDate("", false, false, (result) => {
            this.setState({
                minimumDate_DisinvestNoNeed: new Date(result.MinimumDateTime),
            });
        });

        this.checkDeferredFunds(this.state.assetsTable);
    }

    isValid() {
        const flag = super.isValid();
        var isRestrictedProtection = false;
        if (this.props.data?.PensionQuote?.HasPensionProtection && this.props.data?.PensionQuote?.PensionProtection) {
            isRestrictedProtection = isRestrictedToPensionContribution(
                this.props.data?.PensionQuote?.PensionProtection
            );
            if (isRestrictedProtection) {
                this.props.showErrorMsgPopUp([IsRestrictedToPensionContributionWarningText]);
            }
        }
        if (
            this.props.data?.PensionQuote?.DrawdownModel?.PensionOption == PensionOption.Drawdown &&
            this.props.data?.PensionQuote?.DrawdownModel?.DrawdownCalculations?.HasStopWarning
        ) {
            return false;
        }
        if (
            this.props.data?.PensionQuote?.DrawdownModel?.PensionOption == PensionOption.Drawdown &&
            this.props.data?.PensionQuote?.DrawdownModel?.DrawdownCalculations?.HasFailedStandaloneLumpSumValidation
        ) {
            return false;
        }

        if (
            this.props.data?.PensionQuote?.DrawdownModel?.PensionOption == PensionOption.UFPLS &&
            this.props.data?.PensionQuote?.DrawdownModel?.UfplsWithdrawal?.WithdrawalAmount >
                this.props.data?.PensionQuote?.DrawdownModel?.DrawdownCalculations?.AvailableCash
        ) {
            return false;
        }

        if (this.needIllHealth(this.props.data)) {
            this.props.showErrorMsgPopUp([
                "To take drawdown, Customer whose age < 55 must have ill health.",
            ]);
            return false;
        }

        return flag && !isRestrictedProtection;
    }

    private checkDeferredFunds(assets: ChooseAssetsToSellAssets[]) {
        let deferredInstrumentCodes = assets.filter((a) => a.IsDeferred).map((o) => o.Assets);
        let message = DeferredFundWarningMessage.CannotSwitchFromDeferredFundWarning.replace(
            "<InstrumentCode>",
            deferredInstrumentCodes.join(",")
        );
        this.props.showErrorMsgPopUp([message]);
    }

    componentDidUpdate(prevProps: any): void {
        super.componentDidUpdate(prevProps);
        if (
            this.props.data?.PensionQuote?.DrawdownModel?.IsAcrossAllAssets != undefined &&
            prevProps.data?.PensionQuote?.DrawdownModel?.IsAcrossAllAssets !=
                this.props.data?.PensionQuote?.DrawdownModel?.IsAcrossAllAssets
        ) {
            this.setIsDisinvest();
        }

        if (
            JSON.stringify(prevProps.data?.PensionQuote?.DrawdownModel) !== 
            JSON.stringify(this.props.data?.PensionQuote?.DrawdownModel)) {
            this.updatePensionCommencementLumpSumAllocations();
        }
    }

    componentWillUpdate(nextProps, nextState): void {
        super.componentWillUpdate(nextProps, nextState);

        //assetsTable state change
        if (this.state.assetsTable.length == 0 && nextState.assetsTable.length > 0) {
            this.setIsDisinvest(nextState.assetsTable);
        }
    }

    private getComponentProps = (data: QuoteModel, onChange) => {
        return {
            data: data?.PensionQuote?.DrawdownModel,
            onChange: (v) => {
                this.onDataChange(
                    (changes) => this.onDataChange(onChange, changes, data, "PensionQuote"),
                    v,
                    data.PensionQuote,
                    "DrawdownModel"
                );
            },
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    };

    private getIllustrationChargeProps = (data: QuoteModel, onChange) => {
        return {
            data: data?.PensionQuote,
            onChange: (v) => {
                this.onDataChange(
                    onChange,
                    v,
                    data,
                    "PensionQuote"
                );
            },
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    } 

    private updatePensionCommencementLumpSumAllocations() {
        const { data } = this.props;
        const drawdownModel = data?.PensionQuote?.DrawdownModel;
        if (!drawdownModel || drawdownModel.DrawdownType == DrawdownType.Regular) return;
        
        const isImmediateTaxFreeLumpSum = this.getIsImmediateTaxFreeLumpSum();
        
        if (isImmediateTaxFreeLumpSum) {
            const changes = {
                PensionCommencementLumpSumAllocations: []
            };
            
            this.onDataChange(
                (changeData) => this.onDataChange(this.props.onChange, changeData, this.props.data, "PensionQuote"),
                changes,
                this.props.data.PensionQuote,
                "DrawdownModel"
            );
            return;
        }
        
        const availableCash = drawdownModel?.CrystallisationDetails?.AvailableCash?.Amount || 0;
        const pclsAmount = drawdownModel?.TaxFreeLumpSum?.Amount || 0;
        
        if (!this.state.assetsTable || this.state.assetsTable.length === 0) return;
        
        const cashAsset = this.state.assetsTable.find(a => a.Assets.toUpperCase() === "GBP CASH");
        if (!cashAsset) return;
        
        if (availableCash >= pclsAmount) {
            const pclsAllocations = [{
                ProductId: cashAsset.Id,
                Name: cashAsset.Assets,
                Percentage: 100,
                Type: cashAsset.ProductType
            }];

            const changes = {
                PensionCommencementLumpSumAllocations: pclsAllocations
            };
            
            this.onDataChange(
                (changeData) => this.onDataChange(this.props.onChange, changeData, this.props.data, "PensionQuote"),
                changes,
                this.props.data.PensionQuote,
                "DrawdownModel"
            );
        }
    }

    private setIsDisinvest(assetsTable: ChooseAssetsToSellAssets[] = []) {
        let assetData = this.state.assetsTable.length > 0 ? this.state.assetsTable : assetsTable;
        let assetAllocations = this.props.data?.PensionQuote?.DrawdownModel?.PensionCommencementLumpSumAllocations;
        let isAcrossAllAssets = this.props.data?.PensionQuote?.DrawdownModel?.IsAcrossAllAssets ?? true;

        //if the asset allocation got 100% cash, then disinvestment is not needed
        if (
            (isAcrossAllAssets && assetData && assetData.length == 1) ||
            (!isAcrossAllAssets &&
                assetAllocations &&
                assetData &&
                assetData.some(
                    (x) =>
                        x.Assets.toUpperCase() == "GBP CASH" &&
                        assetAllocations.some((y) => y.ProductId == x.Id && y.Percentage == 100)
                ))
        ) {
            this.setState({
                isDisinvest: false,
            });
            return;
        }

        this.setState({
            isDisinvest: true,
        });
    }

    private doCalculation = (quoteModel?: QuoteModel, amount?: Money) => {
        this.setState({ isLoading: true });
        const originType =
            quoteModel?.PensionQuote?.DrawdownModel?.DrawdownType == null
                ? this.state.originType || QuoteInstructionStore.getData()?.PensionQuote?.DrawdownModel?.DrawdownType
                : quoteModel?.PensionQuote?.DrawdownModel?.DrawdownType;
        const currType = this.props.data?.PensionQuote?.DrawdownModel?.DrawdownType;
        const _data = JSON.parse(JSON.stringify(quoteModel || this.props.data)) as QuoteModel;
        if (_data.PensionQuote?.DrawdownModel?.CrystallisationDetails && amount) {
            _data.PensionQuote.DrawdownModel.CrystallisationDetails.CrystallisationAmount = amount;
        }

        this.setState({ originType: currType });
        const originIsRegular = originType == DrawdownType.Regular;
        const currIsRegular = currType == DrawdownType.Regular;
        _data.PensionQuote.DrawdownModel.ChangeInstructionType =
            (originIsRegular && !currIsRegular) || (!originIsRegular && currIsRegular);
        let changes = { customerID: _data.ClientDetails.ActorId };
        this.onDataChange(this.props.onChange, changes, this.props.data);
        NewQuoteAction.saveQuoteInstruction(1, _data, () => {
            this.setState({ isLoading: false });
        });
    };

    private needIllHealth(data) {
        return (
            this.ageNeedsIllHealth(data) && !data?.PensionQuote?.DrawdownModel?.InstructionId
        );
    }

    private ageNeedsIllHealth(data) {
        return data?.PensionQuote?.PensionProtection?.PensionSchemeSpecificProtection?.ProtectedRetirementAge
            ? false
            : LessThanAge(55, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
    }

    private onIllHealthConfirmed = () => {
        this.setState({
            isLoading: false,
        });
    };

    private getIsImmediateTaxFreeLumpSum(): boolean {
        return (
            this.props.data?.SelectedProducts?.find((ele) =>
                SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType)
            )?.PensionType == PensionType.ImmediateTaxFreeLumpSum
        );
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const ageLessThan75 = LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
        const isImmediateTaxFreeLumpSum = this.getIsImmediateTaxFreeLumpSum();

        if (this.needIllHealth(data)) {
            return (
                <PartLoading isLoading={this.state.isLoading}>
                    <IllHealth
                        {...this.getComponentProps(data, onChange)}
                        getDrawdownModel={() => {
                            this.setState({ isLoading: true });
                            const params = getQueryParameters();
                            DrawdownCalculationAction.postDrawdown(
                                this.props.data?.PensionQuote?.HierarchyId,
                                null,
                                (drawdownModel: DrawdownModel) => {
                                    NewQuoteAction.getQuoteInstruction(params["id"], () =>
                                        this.setState({ isLoading: false })
                                    );
                                    this.setState({ originType: drawdownModel?.DrawdownType });
                                },
                                true
                            );
                        }}
                    />
                </PartLoading>
            );
        }
        return (
            <PartLoading isLoading={this.state.isLoading}>
                <WizardLinter
                    status={EWizardLinterStatus.PleaseComplete}
                    enabled={EWizardLinterHelper.shouldDisplay(SubAccountType.Npr)}
                >
                    <h2>Drawdown details</h2>
                    <PensionProtection
                        {...this.props}
                        onRef={(ref) => this.appendChild(ref)}
                        data={data?.PensionQuote}
                        onChange={(v) => this.onDataChange(onChange, v, data, "PensionQuote")}
                        process={ProcessType.Quote}
                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                    />
                    <ProtectionInformation
                        {...this.getComponentProps(data, onChange)}
                        process={ProcessType.Quote}
                        pensionProtection={data?.PensionQuote?.PensionProtection}
                    />

                    <DrawdownTypeOption
                        isImmediateTaxFreeLumpSum={isImmediateTaxFreeLumpSum}
                        originType={
                            this.state.originType ||
                            QuoteInstructionStore.getData()?.PensionQuote?.DrawdownModel?.DrawdownType
                        }
                        {...this.getComponentProps(data, onChange)}
                        pensionProtection={data?.PensionQuote?.PensionProtection}
                        activityType={data?.ActivityType}
                        PersonalRecommendation={true}
                        canCreateRegularCrystallisation={!data?.PensionQuote.DrawdownModel?.IsIllHealth}
                    />
                    {data?.PensionQuote?.DrawdownModel?.DrawdownType == DrawdownType.Regular && (
                        <RegularCrystallisation
                            {...this.getComponentProps(data, onChange)}
                            process={ProcessType.Quote}
                            doCalculation={() => this.doCalculation()}
                            minimumDate={
                                this.state.isDisinvest
                                    ? this.state.minimumDate_DisinvestNeed
                                    : this.state.minimumDate_DisinvestNoNeed
                            }
                        />
                    )}

                    {(data?.PensionQuote?.DrawdownModel?.DrawdownType == DrawdownType.Capped ||
                        data?.PensionQuote?.DrawdownModel?.DrawdownType == DrawdownType.Flexible) && (
                        <CrystallisationDetailsSection
                            isImmediateTaxFreeLumpSum={isImmediateTaxFreeLumpSum}
                            modelData={this.props.data?.PensionQuote}
                            processType={ProcessType.Quote}
                            cashInstrmentProductId={data?.CashInstrument?.ProductId || 0}
                            doCalculation={(amount?: Money) => this.doCalculation(null, amount)}
                            {...this.getComponentProps(data, onChange)}
                            pensionProtection={data?.PensionQuote?.PensionProtection}
                        />
                    )}

                    {(data?.PensionQuote?.DrawdownModel?.AllowanceDetails?.HasOffPlatformBcePriorApril2024 && !data?.PensionQuote?.DrawdownModel?.AllowanceDetails?.AwareOfBCEAmounts) &&
                        !hasPrimaryProtection(data?.PensionQuote?.PensionProtection) && !hasEnhancedProtectionWithPclsProtection(data?.PensionQuote?.PensionProtection) && (
                            <>
                                <LTABreakdownDetails
                                    doCalculation={() => this.doCalculation()}
                                    {...this.getComponentProps(data, onChange)}
                                    process={ProcessType.Quote}
                                    lessThan75={ageLessThan75}
                                    hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.PensionQuote)}
                                />
                            </>
                        )}
                    <AllowanceDetails
                        doCalculation={() => this.doCalculation()}
                        {...this.getComponentProps(data, onChange)}
                        pensionProtection={data?.PensionQuote?.PensionProtection}
                        hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.PensionQuote)}
                        process={ProcessType.Quote}
                    />
                    <PCLSSection {...this.getComponentProps(data, onChange)} data={data.PensionQuote.DrawdownModel} />
                    <TaxFreeLumpSumPayment
                        doCalculation={this.doCalculation}
                        process={ProcessType.Quote}
                        pensionProtection={data?.PensionQuote?.PensionProtection}
                        {...this.getComponentProps(data, onChange)}
                        lessThan75={LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth))}
                        hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.PensionQuote)}
                    />

                    {data?.PensionQuote?.DrawdownModel?.DrawdownType != DrawdownType.Regular && (
                        <DIAC
                            {...this.getComponentProps(data, onChange)}
                            modelData={this.props.data?.PensionQuote}
                            existingAccount={false}
                        />
                    )}
                    <OAC
                        readonly={true}
                        type={SubAccountType.Npr}
                        onChange={(v) => {}}
                        data={{
                            OngoingAdviceCharge:
                                data?.PensionQuote?.DrawdownModel?.DrawdownAdviserCharge?.OngoingAdviserCharge,
                        }}
                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                        onRef={(ref) => this.appendChild(ref)}
                    />
                    <ChargesOnIllustration {...this.getIllustrationChargeProps(data, onChange)} />

                    {showChooseAssetstoSell(data?.PensionQuote?.DrawdownModel, ChooseAssetsToSellFor.Drawdown)
                    && !isImmediateTaxFreeLumpSum && (
                        <>
                            <hr />
                            <ChooseAssetsToSell
                                {...this.getComponentProps(data, onChange)}
                                tableKey={TableKeys.PensionCommencementLumpSumAllocations}
                                assets={this.state.assetsTable}
                            />
                            {!data?.PensionQuote?.DrawdownModel?.IsAcrossAllAssets && (
                                <ChooseAssetsToSellTable
                                    modelData={data?.PensionQuote?.DrawdownModel}
                                    data={
                                        data?.PensionQuote?.DrawdownModel?.PensionCommencementLumpSumAllocations || []
                                    }
                                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                    tableData={this.state.assetsTable}
                                    onRef={(ref) => this.appendChild(ref)}
                                    onChange={(v) => {
                                        this.onDataChange(
                                            (changes) => this.onDataChange(onChange, changes, data, "PensionQuote"),
                                            { PensionCommencementLumpSumAllocations: v },
                                            data.PensionQuote,
                                            "DrawdownModel"
                                        );
                                        this.setIsDisinvest();
                                    }}
                                    processType={ProcessType.Quote}
                                    reason={ChooseAssetsToSellFor.Drawdown}
                                />
                            )}
                        </>
                    )}
                </WizardLinter>
            </PartLoading>
        );
    }
}
